import { useState, useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import messages from './ApplicantCallAction.messages';
import selfServeSplitTestMessages from './ApplicantCallAction.selfServeSplitTest.messages';
import ApplicantCallModal from './ApplicantCallModal';
import { useIsInSelfServeSplitTest } from '../../../../customHooks/useIsInSelfServeSplitTest';
import { FormalOffer } from '../../../myOffers/MyOffers.types';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';

export const ApplicantCallAction = ({
    productType,
    status
}: {
    productType: FormalOffer['product_type'];
    status: TFundingRequirementsSteps['0']['status'];
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isInSelfServeTest = useIsInSelfServeSplitTest();

    const handleModalClose = () => {
        setIsModalOpen(!isModalOpen);
    };

    const isIwocaPay: boolean = productType === 'iwocapay';

    useEffect(() => {
        if (isInSelfServeTest) {
            tracking.ampli.allSetForNowFundingRequirementMessageShown();
        } else {
            tracking.ampli.giveUsACallFundingRequirementShown();
        }
    }, [isInSelfServeTest]);

    if (isInSelfServeTest) {
        return (
            <StepItem
                title={
                    <FormattedMessage {...selfServeSplitTestMessages.title} />
                }
                caption={
                    <FormattedMessage {...selfServeSplitTestMessages.caption} />
                }
                action={<></>}
            />
        );
    }

    return (
        <>
            <StepItem
                title={<FormattedMessage {...messages.title} />}
                caption={<FormattedMessage {...messages.caption} />}
                action={
                    <FundingStepActionButton
                        actionMessage={
                            <FormattedMessage {...messages.action} />
                        }
                        pendingMessage={
                            <FormattedMessage {...messages.pending} />
                        }
                        status={status === 'PENDING' ? 'REQUIRED' : status}
                        handleFundingStepAction={() => setIsModalOpen(true)}
                    />
                }
            />

            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <ApplicantCallModal
                    onClose={handleModalClose}
                    isIwocaPay={isIwocaPay}
                />
            </Modal>
        </>
    );
};
